import Sidebar from "../../components/Common/Sidebar";
import { WebinarList } from "../../components/_pages/WebinarList";

const Webinar = () => {
  return (
    <>
      <Sidebar />
      <WebinarList />
    </>
  );
};

export default Webinar;
